import React from 'react'
import JobModuleBase from '../JobModuleBase'
import PropTypes from 'prop-types'

import FunctionUtils from '../../../../lambda/FunctionUtils'

export default class NameDescriptionModule extends JobModuleBase {

  static propTypes = {
    jobInfo: PropTypes.shape()
  }

  constructor(props) {
    super(props)
    this.state = {
      name: this.props.jobInfo.modules.displayName.value,
      description: this.props.jobInfo.modules.description.value
    }
  }

  setName = (value) => {
    FunctionUtils.updateModule(this.props.jobInfo,
      '/modules/displayName/value', value, true)
  }

  setDescription = (value) => {
    FunctionUtils.updateModule(this.props.jobInfo,
      '/modules/description/value', value, true)
  }

  handleNameChanged = (event) => {
    this.setName(event.target.value)
    this.setState({
      name: event.target.value
    })
  }

  handleDescriptionChanged = (event) => {
    this.setDescription(event.target.value)
    this.setState({
      description: event.target.value
    })
  }

  render() {
    // Avoid changing from controlled to uncontrolled component
    // setting the value of the inputs to undefined
    const name = this.state.name || ''
    const description = this.state.description || ''
    return (
      <div style={styles.moduleContainer}>
        <input
          style={{ ...styles.input, ...styles.nameInput }}
          value={name}
          placeholder={'Job name (brief description)'}
          onChange={this.handleNameChanged} />
        <textarea
          style={{ ...styles.input, ...styles.descriptionInput }}
          rows={5}
          value={description}
          placeholder={'Full description'}
          onChange={this.handleDescriptionChanged} />
      </div>
    )
  }

}

const styles = {

  moduleContainer: {
    display: 'flex',
    flexDirection: 'column'
  },

  input: {
    fontSize: 14,
    padding: '7px 11px 7px 11px',
    backgroundColor: '#fefefe',
    borderRadius: 3,
    boxShadow: 'inset 0 2px 2px 0 rgba(0, 0, 0, 0.05)',
    border: 'solid 1px rgba(0, 0, 0, 0.12)'
  },

  nameInput: {
    width: '55%'    
  },

  descriptionInput: {
    marginTop: 15,
    resize: 'none'
  }

}


// WEBPACK FOOTER //
// ./src/schedule/common/modules/text/NameDescriptionModule.js